import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';
import '@medprompt/shared/src/common/modals.css';
import './ViewersWarningModal.css';

const ViewersWarningModal = ({ 
  viewers, 
  activeUsers, 
  currentUser, 
  onDismiss, 
  onBackToDocuments 
}) => {
  // Filter out current user from viewers list (using same logic as viewer tooltip)
  const otherViewers = viewers.filter(viewer => viewer.userId !== currentUser?.userId);
  
  console.log('ViewersWarningModal - All viewers:', viewers);
  console.log('ViewersWarningModal - Current user ID:', currentUser?.userId);
  console.log('ViewersWarningModal - Other viewers:', otherViewers);
  
  if (otherViewers.length === 0) {
    console.log('ViewersWarningModal - No other viewers, not showing modal');
    return null; // Don't show modal if no other viewers
  }

  return (
    <div className="modal-overlay">
      <div className="modal-container modal-animated viewers-warning-modal">
        <div className="modal-header">
          <div className="modal-title">
            <FontAwesomeIcon icon={faExclamationTriangle} className="warning-icon" />
            <h2>Document Currently Being Viewed</h2>
          </div>
          <button className="close-button" onClick={onDismiss}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        
        <div className="modal-content">
          <p className="warning-message">
            This document is currently being viewed by {otherViewers.length} other user{otherViewers.length > 1 ? 's' : ''}:
          </p>
          
          <div className="viewers-list">
            {otherViewers.map((viewer, index) => {
              const viewerUser = activeUsers.find(u => u.userId === viewer.userId);
              return (
                <div key={viewer.userId || index} className="viewer-item">
                  <div className="viewer-name">
                    {viewerUser?.name || 'Unknown User'}
                  </div>
                  {viewerUser?.email && (
                    <div className="viewer-email">{viewerUser.email}</div>
                  )}
                </div>
              );
            })}
          </div>
          
          <p className="collaboration-note">
            Multiple users viewing the same document may lead to conflicting changes. 
            Consider coordinating with other viewers before making modifications.
          </p>
        </div>
        
        <div className="modal-actions">
          <button className="cancel-button" onClick={onBackToDocuments}>
            Back to Documents
          </button>
          <button className="dismiss-button" onClick={onDismiss}>
            Continue Anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewersWarningModal;
